import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function aboutTeam () {
	const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	document.querySelectorAll('.about-team').forEach((section) => {
		const bar = section.querySelector('.nav-cover-bar');
		if (bar) {
			ScrollTrigger.create({
				trigger: section,
				start: 'top top',
				end: 'bottom top',
				onToggle: (self) => bar.classList.toggle('is-fixed', self.isActive),
			});
		}
		bindPeople(section, reduce);
	});

	ScrollTrigger.refresh();
}

function bindPeople (section, reduce) {
	const scroller = section.querySelector('.results');
	const cards = [...section.querySelectorAll('.person')];
	const dots = [...section.querySelectorAll('.results-dot')];
	const prev = section.querySelector('.results-prev');
	const next = section.querySelector('.results-next');
	if (! scroller || cards.length < 2 || ! dots.length) return;

	const inset = () => parseFloat(getComputedStyle(scroller).scrollPaddingLeft) || 0;

	const nearest = () => {
		const edge = scroller.getBoundingClientRect().left + inset();
		let active = 0;
		let best = Infinity;
		cards.forEach((card, index) => {
			const distance = Math.abs(card.getBoundingClientRect().left - edge);
			if (distance < best) {
				best = distance;
				active = index;
			}
		});
		return active;
	};

	const go = (index) => {
		const card = cards[Math.max(0, Math.min(cards.length - 1, index))];
		if (! card) return;
		const left = card.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft - inset();
		scroller.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
	};

	const paint = () => {
		const active = nearest();
		dots.forEach((dot, index) => {
			const on = index === active;
			dot.classList.toggle('is-active', on);
			if (on) dot.setAttribute('aria-current', 'true');
			else dot.removeAttribute('aria-current');
		});
		if (prev) prev.disabled = active === 0;
		if (next) next.disabled = active === cards.length - 1;
	};

	scroller.addEventListener('scroll', paint, { passive: true });
	dots.forEach((dot, index) => {
		dot.addEventListener('click', () => go(index));
	});
	prev?.addEventListener('click', () => go(nearest() - 1));
	next?.addEventListener('click', () => go(nearest() + 1));
	paint();
}
